__webpack_require__.p = "/wallet/";